/* eslint-disable @next/next/no-img-element */
import { OfficeSiteContext } from '@context/OfficeSiteContext'
import { UserContext } from '@context/UserContext'
import useBodyClass from '@hooks/useBodyClass'
import { Link, Router } from '@routes'
import { useContext, useEffect, useRef, useState } from 'react'
import AppraisalButton from './AppraisalButton'
import Menu from './Menu'

const Nav = ({ menuData, isTransparentHeader }) => {
  const { megaNavMenus, mainMenu } = menuData
  const officeContext = useContext(OfficeSiteContext)
  const { userProfile } = useContext(UserContext)
  const [menuOpen, setMenuOpen] = useState(null)
  const [navState, setNavState] = useState('top')
  const navRef = useRef(null)
  const prevScrollY = useRef(0)

  const closeMenu = () => {
    setMenuOpen(false)
  }

  useBodyClass('menu-open', menuOpen)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const isScrollingUp = scrollY < prevScrollY.current

      if (scrollY <= 1) {
        setNavState('top')
      } else if (isScrollingUp) {
        setNavState('scrolling')
      } else if (scrollY > 1 && scrollY <= 400) {
        setNavState('scrolling')
      } else {
        setNavState('invisible')
      }

      prevScrollY.current = scrollY
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    Router.events.on('routeChangeComplete', () => {
      closeMenu()
    })

    return () => {
      Router.events.off('routeChangeComplete', closeMenu)
    }
  }, [])

  const renderAccount = () => {
    return (
      <>
        {userProfile?.first_name ? (
          <div className='bp-nav__actions__links'>
            <Link route='/my-account/' passHref>
              <div className='user-info'>My account</div>
            </Link>
          </div>
        ) : (
          <div className='bp-nav__actions__links'>
            <Link route='/login/' passHref prefetch={false}>
              Sign in
            </Link>
            <span className='divider' />
            <Link route='/create-account/' passHref prefetch={false}>
              Join
            </Link>
          </div>
        )}
      </>
    )
  }

  return (
    <nav
      className={`bp-nav ${isTransparentHeader ? 'bp-nav-transparent' : ''} ${
        menuOpen ? 'active' : ''
      } bp-nav--${navState}`}
      ref={navRef}
    >
      <div
        className={`bp-nav__container ${
          officeContext?.currentSite?.officeId ? 'with-office' : ''
        }`}
      >
        <div className='bp-nav__header'>
          <div
            className={`bp-logo ${
              officeContext?.currentSite?.officeId ? 'with-office' : ''
            }`}
          >
            <Link
              route={officeContext?.currentSite?.officePath || '/'}
              passHref
            >
              <img src='/imgs/logo.png' className='logo' alt='Barryplant' />
              <img
                src='/imgs/logo-sand.png'
                className='logo-sand'
                alt='Barryplant'
              />
            </Link>
          </div>

          <Menu
            open={menuOpen}
            setMenuOpen={setMenuOpen}
            menuItems={
              officeContext?.currentSite?.officeId
                ? officeContext?.currentSite?.mainMenu
                : mainMenu
            }
            withOffice={officeContext?.currentSite?.officeId}
          />

          <div className='bp-nav__actions'>
            {officeContext?.currentSite?.officeId && (
              <Link
                className='bp-office-name'
                route={officeContext?.currentSite?.officePath}
                passHref
              >
                <span className='hidden-mb'>Barry Plant</span>{' '}
                {officeContext?.currentSite?.officeName}
              </Link>
            )}
            <div>
              {renderAccount()}
              <div
                className={`mobile-burger ${menuOpen ? 'close' : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>

        <div className='bp-nav__body'>
          <Menu
            menuItems={
              officeContext?.currentSite?.officeId
                ? officeContext?.currentSite?.megaNavMenus
                : megaNavMenus
            }
            withOffice={officeContext?.currentSite?.officeId}
            isSubMenu
            setMenuOpen={setMenuOpen}
          />

          <AppraisalButton />
          {renderAccount()}
        </div>
        <div className='bp-nav__footer'>
          {renderAccount()}
          <AppraisalButton />
        </div>
      </div>
    </nav>
  )
}

export default Nav
